import { sendBlogEvent } from '../analytics.js';
import { isCtaHost, isOutboundHost, classifyLocation } from './outbound-domains.js';

const BLOG_HOST = 'blog.gtowizard.com';

function enrichUrlWithUtm(url, { campaign, content }) {
  let parsed;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }
  if (!isCtaHost(parsed.host)) return null;

  const sp = parsed.searchParams;
  if (!sp.has('utm_source')) sp.set('utm_source', BLOG_HOST);
  if (!sp.has('utm_medium')) sp.set('utm_medium', 'referral');
  if (campaign && !sp.has('utm_campaign')) sp.set('utm_campaign', campaign);
  if (content && !sp.has('utm_content')) sp.set('utm_content', content);

  return parsed.toString();
}

function computeCampaign() {
  const slug = window.GhostConfig?.post?.slug;
  if (slug) return slug;
  const path = window.location.pathname.replace(/^\/|\/$/g, '');
  return path || 'home';
}

function anchorText(anchor) {
  return (anchor.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 80);
}

function ctaLabel(anchor) {
  return (
    anchor.getAttribute('data-cta') ||
    anchor.getAttribute('aria-label')?.trim() ||
    anchorText(anchor) ||
    anchor.href
  );
}

function buildHandleClick(campaign) {
  return function handleClick(e) {
    const anchor = e.target instanceof Element ? e.target.closest('a[href]') : null;
    if (!anchor) return;

    const rawHref = anchor.getAttribute('href');
    if (!rawHref || rawHref.startsWith('#') || rawHref.startsWith('mailto:') || rawHref.startsWith('tel:')) return;

    let url;
    try {
      url = new URL(anchor.href);
    } catch {
      return;
    }

    if (url.protocol !== 'http:' && url.protocol !== 'https:') return;
    // Skip same-host navigation unless explicitly tagged as a CTA
    // (covers both prod blog.gtowizard.com and localhost dev).
    if (url.host === window.location.host && !anchor.hasAttribute('data-cta')) return;
    if (url.host === BLOG_HOST) return;

    const isCta = anchor.hasAttribute('data-cta') || isCtaHost(url.host);
    const isOutbound = !isCta && isOutboundHost(url.host);
    if (!isCta && !isOutbound) return;

    const location = classifyLocation(anchor);

    if (isCta) {
      const enriched = enrichUrlWithUtm(anchor.href, { campaign, content: location });
      if (enriched) {
        anchor.href = enriched;
      }
      sendBlogEvent('cta_click', {
        cta_label: ctaLabel(anchor),
        cta_destination: anchor.href,
        cta_location: location
      });
      return;
    }

    sendBlogEvent('outbound_click', {
      destination_url: anchor.href,
      destination_host: url.host,
      link_text: anchorText(anchor),
      cta_location: location
    });
  };
}

let installed = false;
export function initLinkTracker() {
  if (installed) return;
  installed = true;
  // Capture phase so we run before any other click handler's preventDefault().
  document.addEventListener('click', buildHandleClick(computeCampaign()), true);
}
